import { useLocation, useNavigate } from "@solidjs/router";
import { createEffect, onCleanup, onMount } from "solid-js";
import { goBack } from "../lib/nav";
import { getTelegramWebApp } from "../lib/telegram";
import { bindTelegramTheme } from "../lib/tgTheme";

const TAB_ROOTS = new Set(["/", "/exercises", "/stats", "/profile"]);

/** Keeps Telegram theme, header, and native BackButton in sync with the router. */
export default function TelegramChrome() {
  const location = useLocation();
  const navigate = useNavigate();

  onMount(() => {
    const unbindTheme = bindTelegramTheme();
    const wa = getTelegramWebApp();
    try {
      wa?.MainButton?.hide?.();
      wa?.SecondaryButton?.hide?.();
    } catch {
      /* older clients */
    }

    const onBack = () => goBack(navigate, "/");
    wa?.BackButton?.onClick?.(onBack);

    onCleanup(() => {
      unbindTheme();
      try {
        wa?.BackButton?.offClick?.(onBack);
        wa?.BackButton?.hide?.();
      } catch {
        /* older clients */
      }
    });
  });

  createEffect(() => {
    const path = location.pathname;
    const wa = getTelegramWebApp();
    try {
      if (TAB_ROOTS.has(path)) wa?.BackButton?.hide?.();
      else wa?.BackButton?.show?.();
    } catch {
      /* older clients */
    }
  });

  return null;
}
